import { ModalDialog, ModalDialogProps } from 'commons/components';
import { PocButton, PocProgressSpinner } from 'commons/components/components-wrapper';
import React from 'react';
import { PopupProps } from 'react-popup-manager';

export interface ConfirmationModalComponentProps extends React.PropsWithChildren, PopupProps {
    title: string | React.ReactNode;
    buttonText: string;
    isDeleteAction?: boolean;
    cancelButtonText?: string;
    executeOnCloseOnAction?: boolean;
    disabledActionButton?: boolean;
    actionOnClick: () => Promise<unknown>;
    size?: ModalDialogProps['size'];
}

const keepOpenForRetry = () => undefined;

export const ConfirmationModalComponent: React.FC<ConfirmationModalComponentProps> = (props) => {
    const {
        isOpen,
        title,
        children,
        buttonText,
        isDeleteAction = false,
        cancelButtonText,
        executeOnCloseOnAction = true,
        disabledActionButton = false,
        actionOnClick,
        onClose,
        size,
    } = props;

    const [isConfirming, setIsConfirming] = React.useState(false);
    const handleOnClick = () => {
        setIsConfirming(true);
        actionOnClick()
            .then(() => {
                if (executeOnCloseOnAction) {
                    onClose?.();
                }
            })
            .catch(keepOpenForRetry)
            .finally(() => setIsConfirming(false));
    };

    return (
        <ModalDialog
            title={title}
            footerOptions={
                <PocButton
                    variant="primary"
                    status={isDeleteAction ? 'alarm' : 'default'}
                    size="medium"
                    onClick={handleOnClick}
                    disabled={disabledActionButton || isConfirming}
                >
                    {isConfirming ? <PocProgressSpinner size="xSmall" style={{ display: 'block' }} /> : buttonText}
                </PocButton>
            }
            cancelButtonText={cancelButtonText}
            cancelButtonDisabled={disabledActionButton || isConfirming}
            onClose={onClose}
            isOpen={isOpen}
            size={size}
        >
            {children}
        </ModalDialog>
    );
};
